import React, { useState, useEffect, useRef } from 'react';
import { Paper, withStyles, CircularProgress } from '@material-ui/core';
import DriverRecommendationCard from '../../../../Recommendations/common/DriverRecommendationCard';
import { getRecommendationKPIFromCache, setRecommendationKPIInCache } from './recommendationCache';
import styles from './styles';
import axios from 'axios';

const RecommendationKPI = ({ groupId, routeId, api, classes }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState('Please wait while we fetch recommendation KPIs...');
  const isMountedRef = useRef(true);
  const kpiDataRef = useRef({});
  const source = useRef(axios.CancelToken.source());

  useEffect(() => {
    isMountedRef.current = true;
    const kpiCashedData = getRecommendationKPIFromCache(groupId);
    if (kpiCashedData) {
      kpiDataRef.current = kpiCashedData;
      setIsLoading(false);
      setError(null);
    } else {
      fetchRecommendationKPI();
    }
    return () => {
      isMountedRef.current = false;
      source.current.cancel('RecommendationKPI unmounted');
    };
  }, [groupId, routeId]);

  const fetchRecommendationKPI = () => {
    api.runCommand('fetchRecommendationKPI', {
      groupId,
      cancelToken: source.current.token
    }).then((res) => {
      if (isMountedRef.current) {
        const { data, success } = res;
        if (success && data) {
          kpiDataRef.current = data;
          setRecommendationKPIInCache(groupId, data);
          setError(null);
        } else {
          setError('Failed to load recommendation KPIs');
          setRecommendationKPIInCache(groupId, null);
        }
        setIsLoading(false);
      }
    });
  };

  if (error || isLoading) {
    return (
      <Paper className={classes.recommendationContainer}>
        {isLoading && <CircularProgress size={24} className={classes.loader} />}
        <span className={classes.errorLabel}>{error}</span>
      </Paper>
    );
  }
  return <DriverRecommendationCard data={kpiDataRef.current} kpiBorderClass={classes.recommendationKPIBorder}/>;
};

export default withStyles(styles)(RecommendationKPI);
